import React, { useCallback } from "react";
import { Contract, EarningType, Mission } from "../../__generated__/graphql";
import { Buildable } from "ts-essentials";
import { WorkingTimeComponentProps } from "./helpers";
import MonthlyClassicComponent from "./MonthlyClassicComponent";
import HourlyClassicComponent from "./HourlyClassicComponent";
import DailyClassicComponent from "./DailyClassicComponent";
import PackageClassicComponent from "./PackageClassicComponent";

type MissionWorkingTimeEditor = {
    mission: Buildable<Mission>;
    setMission: (m: Buildable<Mission>) => void;
};

const MissionWorkingTimeEditor: React.FC<MissionWorkingTimeEditor> = ({ mission, setMission }) => {
    const earningType = mission.currentContract?.earningType;
    const contract = mission.currentContract as Buildable<Contract>;
    const setContract = useCallback(
        (c: Buildable<Contract>) => setMission({ ...mission, currentContract: c }),
        [mission, setMission],
    );
    const WorkingTimeComponent: React.FC<WorkingTimeComponentProps> = (() => {
        switch (earningType) {
            case EarningType.Monthly:
                return MonthlyClassicComponent;
            case EarningType.Daily:
                return DailyClassicComponent;
            case EarningType.Hourly:
                return HourlyClassicComponent;
            case EarningType.Package:
                return PackageClassicComponent;
            default:
                throw new Error("Unknown working time");
        }
    })();

    return <WorkingTimeComponent contract={contract} setContract={setContract} />;
};

export default MissionWorkingTimeEditor;
